import earn from '../../assets/earn2.png'; 

import './EarnSection.css';


const EarnSection = () => {

  return (
     <div className="earn-section">
        <h1
         data-aos="fade-down"         
         data-aos-duration="700"    
         data-aos-once="true"
        >Earn faster, earn with confidence</h1>
        <p
         data-aos="zoom-in"         
         data-aos-duration="700"    
        >Earn Passive Income Effortlessly. With our powerful cloud technology, we run all wallet searching on our servers, leaving you with no further costs. You have full control over how much you want to run your operations on our cloud servers. Earning online has never been easier, <span className="highlight-text">don't miss out again</span>.</p>
        <img draggable='false' src={earn} alt="Cloud Servers" />

          <div className="button-container">
            <div className="search-cont">
              <h2>SEARCH</h2>
            </div>
            <div className="search-cont">
              <h2>FIND</h2>
            </div>
            <div className="search-cont">
              <h2>ENJOY</h2>
          </div>
        </div>
      </div>
  );
};

export default EarnSection;
